import httpClient from "./httpClient";
import notes from "./note.js";

export default {
  async getCustomers() {
    const response = await httpClient.get(`/customers`);
    return response.data;
  },

  async getCustomer(id) {
    const response = await httpClient.get(`/customers/${id}`);
    return response.data;
  },

  async createCustomer(customer) {
    const response = await httpClient.post(`/customers`, {
      ...customer
    });
    return response.data;
  },

  async updateCustomer(customer) {
    const response = await httpClient.put(`/customers/${customer.id}`, {
      ...customer
    });
    return response.data;
  },

  async deleteCustomer(customer) {
    const response = await httpClient.delete(`/customers/${customer.id}`);
    return response.data;
  },

  async findCustomer(criteria) {
    const response = await httpClient.post(`/customers/search`, {
      criteria
    });
    return response.data;
  },

  /**
   * Tags
   */
  async getCustomerTags() {
    const response = await httpClient.get(`/customers/tags`);
    return response.data;
  },

  async addCustomerTag(customer, tagId) {
    const response = await httpClient.post(`/customers/${customer.id}/tags`, {
      tag: tagId
    });
    return response.data;
  },

  async removeCustomerTag(customer, tagId) {
    const response = await httpClient.delete(
      `/customers/${customer.id}/tags/${tagId}`
    );
    return response.data;
  },

  /**
   * Notes
   */
  ...notes,

  async getBookings(customer) {
    const response = await httpClient.get(`/customers/${customer.id}/bookings`);
    return response.data;
  },

  async getHistoricBookings(customer) {
    const response = await httpClient.get(
      `/customers/${customer.id}/historic_bookings`
    );
    return response.data;
  },

  async getEnquiries(customer) {
    const response = await httpClient.get(
      `/customers/${customer.id}/enquiries`
    );
    return response.data;
  },

  async getAttachments(customer) {
    const response = await httpClient.get(
      `/customers/${customer.id}/attachments`
    );
    return response.data;
  },

  async getTravellerInfo(customer) {
    const response = await httpClient.get(
      `/customers/${customer.id}/traveller-info`
    );
    return response.data;
  },

  async saveTravellerInfo(customer, travellerInfo) {
    const response = await httpClient.post(
      `/customers/${customer.id}/traveller-info`,
      {
        ...travellerInfo
      }
    );
    return response.data;
  }
};
